module.exports = __webpack_public_path__ + "img/icon-Farm.ea028347.svg";